<template>
  <div class="flex flex-col w-full">
    <button
      class="flex items-center px-[16px] py-2 gap-x-2 min-h-[40px] bg-[#FBFBFB] hover:bg-gray-200/80 transition cursor-pointer"
      @click="opened = !opened; $emit('click', folder.id)"
    >
      <svg
        width="17"
        height="18"
        viewBox="0 0 17 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="w-4 h-4"
      >
        <g clip-path="url(#clip0_15295_11506)">
          <path
            d="M13.5778 15.8879H0.45875C0.156853 15.8879 -0.0626813 15.6012 0.0161635 15.3096L2.99585 7.14052C3.04978 6.94063 3.23122 6.8017 3.43844 6.8017H16.5575C16.8594 6.8017 17 7.09011 17 7.37999L14.0204 15.5491C13.9664 15.749 13.785 15.8879 13.5778 15.8879Z"
            fill="#94B8FC"
          />
          <path
            d="M14.7337 4.16378H7.32759L5.86207 2.11206H0.507655C0.227448 2.11206 0 2.33922 0 2.61972V15.1434C0.0202241 15.144 0.0404483 15.1452 0.0600862 15.1464L2.99552 7.14054C3.04945 6.94035 3.23088 6.80172 3.4381 6.80172H15.2414V4.67144C15.2414 4.39094 15.0139 4.16378 14.7337 4.16378Z"
            fill="#4F83E3"
          />
        </g>
        <defs>
          <clipPath id="clip0_15295_11506">
            <rect
              width="17"
              height="17"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>

      <span class="text-sm text-[#44474A] font-semibold text-wrap text-truncate">
        {{ folder.name }}
      </span>

      <svg
        v-if="!opened"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="w-[14px] h-[14px]"
      >
        <path
          d="M1.75 2.33333H3.73333C5.69352 2.33333 6.67361 2.33333 7.4223 2.71481C8.08087 3.05036 8.6163 3.58579 8.95186 4.24436C9.33333 4.99305 9.33333 5.97314 9.33333 7.93333L9.33333 11.6667M9.33333 11.6667L6.41667 8.75M9.33333 11.6667L12.25 8.75"
          stroke="#B5B5B5"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-else
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="w-[14px] h-[14px]"
      >
        <path
          d="M1.75 11.6667H3.73333C5.69352 11.6667 6.67361 11.6667 7.4223 11.2852C8.08087 10.9497 8.6163 10.4142 8.95186 9.75565C9.33333 9.00696 9.33333 8.02687 9.33333 6.06669L9.33333 2.33335M9.33333 2.33335L6.41667 5.25002M9.33333 2.33335L12.25 5.25002"
          stroke="#B5B5B5"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <div
      v-if="opened"
      class="flex flex-col w-full"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagePreviewFolder',
  props: {
    folder: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      opened: false
    }
  }
}
</script>
